module.exports = __webpack_public_path__ + "static/img/0000趣拍拍2.50842e5.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/0000趣拍拍2.jpg
// module id = 2BX/
// module chunks = 0